import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { LocalStorageUser } from '@utils/interfaces/localStorage';
import { SessionService } from '@utils/services/session.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ValidateOtpGuard {

  private _router = inject(Router);
  private _sessionService = inject(SessionService);

  canActivate(): Observable<boolean> | Promise<boolean> | boolean | undefined {
    if (this._sessionService.user && this._sessionService.user.validate_otp === false) {
      this._router.navigateByUrl('/auth/validar');
      return false;
    } else {
      return true;
    }
  }

  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if(this._sessionService.user){
        if(this._sessionService.user.validate_otp === true){
          return true;
        }
        else
          return false;
      } else {
        return true;
      }
    }
  }
